/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import BettingHistoryTab from '@views/BettingHistory/BettingHistoryTab'
// css
import { PageBgStyle } from '@styles/base.style'
import { Button } from '@styles/button.style'
// icon
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import BettingHistoryBg from '@assets/images/bg/betting-history-bg.png'
import { BettingListSelectorWrap, ModalBottomBtnStyle } from './index.style'
import { PAGE_TYPE } from '@interface/common'
import * as Utils from '@utils/utils'

interface BettingListSelectorProps {
  onClick?: () => void
  pageType?: PAGE_TYPE
}

export const BettingListSelector: React.FC<BettingListSelectorProps> = observer((props) => {
  const { pickStore, globalStore, bettingHistoryStore } = useRootStore()
  const {
    selectedBettingHistory,
    selectedBettingHistoryFold,
    selectedBettingHistoryFoldData,
  } = bettingHistoryStore
  const { onClick, pageType } = props

  // full-modal className 을 붙이기 위해.
  const isFullModal = true

  const fetchPublishItem = async () => {
    await pickStore.fetchPublishPick({})
  }

  useOnMount(fetchPublishItem)

  const onClickBetHistoryItemUploadHandler = () => {
    const fromViewType = bettingHistoryStore.bettingHistoryInitProps.fromViewType
    if (selectedBettingHistory[fromViewType] && selectedBettingHistoryFold && selectedBettingHistoryFoldData) {
      globalStore.closeGeneralPopup()

      if (onClick) {
        onClick()
      }
    } else {
      Utils.showToast(Utils.TOAST_TYPE.INFO, '경기를 선택해주세요.')
    }
  }

  return (
    <Fragment>
      <BettingListSelectorWrap>
        <div css={PageBgStyle} className="betting-history-bg">
          <img src={BettingHistoryBg} alt="야구선수 배경"/>
        </div>
        <BettingHistoryTab pageType={pageType} isFullModal={isFullModal}/>
      </BettingListSelectorWrap>

      <Button primary css={ModalBottomBtnStyle} onClick={onClickBetHistoryItemUploadHandler}>확인</Button>
    </Fragment>
  )
})
